// extracted by mini-css-extract-plugin
export default {"customPhoneNumber":"styles_customPhoneNumber__Ul1Ft","error":"styles_error__Ie9o8"};